import LongTemplateComponent from "/components/templates/long-template/long-template";
import BaseTemplatePage from "./base-template-page";

export default class LongTemplatePage extends BaseTemplatePage {
  render() {
    const { pageConfig, errorCode } = this.props;
    if (errorCode) return <Error statusCode={errorCode} />;

    return <LongTemplateComponent {...this.props} />;
  }
}
